import {MutationTree} from "vuex";
import moment from 'moment';
import ISubPanel from "@/modules/SubPanels/ts/ISubPanel";
import IApiClient from "@/modules/PanelSettings/ts/IApiClient";

export const mutations: MutationTree<any> = {
    setLoading(state: any, payload: boolean) {
        state.loading = payload;
    },

    setSaving(state: any, payload: boolean) {
        state.saving = payload;
    },

    setUploading(state: any, payload: boolean) {
        state.uploading = payload;
    },

    setSubPanel(state: any, payload: any) {
        const index = state.subPanels.findIndex((subPanel: ISubPanel) => subPanel.id === payload.id);
        if (index===-1) {
            console.error("Sub panel not found");
        } else {
            state.subPanels.splice(index, 1, payload);
        }
    },

    setData(state: any, payload: Array<ISubPanel>) {
        state.subPanels = payload;
        state.expires = moment().add(15, 'minutes');
    },

    setSubPanelTranslations(state: any, payload: Array<any>) {
        state.subPanelTranslations = payload;
    },

    delete(state: any, id: number) {
        let index = state.subPanels.findIndex( (sp: ISubPanel) => {
            return sp.id == id;
        });
        state.subPanels.splice(index, 1);
    },

    create(state: any, subPanel: ISubPanel) {
        state.subPanels.push(subPanel);
    },

    update(state: any, subPanel: ISubPanel) {

        let found = state.subPanels.find( (sp: ISubPanel) => {
            return sp.id === subPanel.id;
        });

        found = Object.assign(found,subPanel);
    },

    setApiClients(state: any, payload: any) {
        state.apiClients = payload;
    },

    addApiClient(state: any, payload: any) {
        state.apiClients.push(payload);
    },

    deleteApiClient(state: any, id: number) {
        const index = state.apiClients.findIndex((client: IApiClient) => client.id === id);
        state.apiClients.splice(index, 1);
    },

    clearApiClients(state: any) {
        state.apiClients = [];
    },

    enableRegistrationSurvey(state: any, payload: any) {
        let found = state.subPanels.find((subPanel: ISubPanel) => subPanel.id === payload.sub_panel_id);
        found.registration_survey = payload;
    },
};
